import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ComponentLayout from './ComponentLayout';
import HeadingGroup from './HeadingGroup';
import PricingCard from './PricingCard';

const PricingView = (props) => {
const data = props.pricingView;
  return (
    <div className="pricing-group-wrapper">
        <ComponentLayout >
            <HeadingGroup headingStrongText="Pricing" />
            <Grid container spacing={6} className="cards-wrapper">
                {data.pricingCards.map((card)=>{
                    return(
                        <Grid item sm={4} xs={12}>
                            <PricingCard pricingCardData={card.cardData} />
                        </Grid>
                    )
                })}
            </Grid>
        </ComponentLayout> 
    </div>
  );
};

PricingView.propTypes = {
    pricingView: PropTypes.any,
}

export default PricingView;